module.exports = __webpack_public_path__ + "img/oshimi.2daf1297.jpg";